import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IAppState } from '@myStore/app.state';
import {
  EditAvatarFailure,
  EditAvatarRequest,
  EditAvatarSuccess,
  EditSelfProfileFailure,
  EditSelfProfileRequest,
  EditSelfProfileSuccess,
  EProfileChangesActions,
} from '@myStore/profile-changes/profile-changes.actions';
import {
  GetProfileRequest,
  UpdateProfileAvatar,
} from '@myStore/profile-view/profile-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ProfileChangesService } from '@services/profile-changes/profile-changes.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ProfileChangesEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _router: Router,
    private _toastr: ToastrService,
    private _profileChangesService: ProfileChangesService
  ) {}

  editSelfProfile$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditSelfProfileRequest>(
          EProfileChangesActions.EditSelfProfileRequest
        ),
        switchMap(action => {
          return this._profileChangesService
            .edit(action.id, action.userData)
            .pipe(
              map(() => {
                this._store.dispatch(new GetProfileRequest(action.id));
                this._store.dispatch(new EditSelfProfileSuccess());
                this._toastr.success('Профиль успешно изменен!');
                this._router.navigate(['/profile'], {
                  queryParams: { edit: false },
                });
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При изминении профиля возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  { timeOut: 3500 }
                );
                this._store.dispatch(new EditSelfProfileFailure(err.error));
                return err;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  editAvatar$ = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<EditAvatarRequest>(EProfileChangesActions.EditAvatarRequest),
        switchMap(action => {
          return this._profileChangesService.editAvatar(action.data).pipe(
            map(res => {
              this._store.dispatch(new UpdateProfileAvatar(res));
              this._store.dispatch(new EditAvatarSuccess());
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось загрузить аватар'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new EditAvatarFailure(err.error));
              return err;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
